import { AEMPromptData, PromptData } from '../WebPromptBanner.types';

// Mock prompt data from AEM
export const mockPromptList: PromptData[] = [
  {
    promptVariation: 'V1',
    promptCTALabel: 'Update Preferences',
    promptTitle: 'Stay in the Know',
    promptRedirectURL: '#',
    promptKey: 'web-prompt-consent-flyout',
    promptSubTitle:
      'Receive personalized communications, including offers, details about promotions, and travel-related products. ',
  },
  {
    promptVariation: 'V2',
    promptCTALabel: 'Update My Account',
    promptTitle: 'Add Your Mobile Phone Number',
    promptRedirectURL: '#',
    promptKey: 'web-prompt-mobile-flyout',
    promptSubTitle:
      'Enjoy the ease of receiving verification codes via text, plus get updates about your stay and personalized offers when you add a mobile number to your account.',
  },
  {
    promptVariation: 'V3',
    promptCTALabel: 'Download the App',
    promptTitle: 'Wishlists Are the New Favorites',
    promptRedirectURL: 'https://www.marriott.com/marriott-brands/mobile-app.mi',
    promptKey: 'web-prompt-wishlist-flyout',
    promptSubTitle:
      "Soon, we'll be replacing the Favorites tab with Wishlists, which are already available in the app. To keep existing favorites, head to the app and save them to a wishlist.",
  },
];

// Mock AEM JSON response
export const mockAEMData: AEMPromptData = {
  ':type': 'mi-aem-account/components/content/webpromptbanner',
  webPromptBannerType: 'STATIC',
  promptList: mockPromptList,
};
